<template>
    <div class="container mt-5 pt-5 text-center d-flex-center flex-column">
        <div class="text-primary-xlight d-flex-center flex-nowrap">
            <i class="fa-solid fa-4 fa-8x mx-2"></i>
            <i class="fa-solid fa-0 fa-8x mx-2"></i>
            <i class="fa-solid fa-4 fa-8x mx-2"></i>
        </div>
        <h1 class="text-bold bg-transparent text-primary my-4 av85 fw-bold" style="font-size: 5vh">Page Introuvable</h1>
        <h2 v-if="isErrorUrl" class="text-bold bg-transparent text-danger my-4 av85 fw-bold" style="font-size: 5vh">
            URL INVALIDE
        </h2>

        <router-link to="/" class="btn rounded-pill btn-primary av85">Retour à l'accueil</router-link>
    </div>
</template>

<script>
export default {
    data() {
        const _isErrorUrl = localStorage.getItem("isErrorUrl") === "true";

        if (_isErrorUrl) {
            localStorage.removeItem("isErrorUrl");
        }

        return {
            isErrorUrl: _isErrorUrl,
        };
    },
};
</script>
